import { motion } from 'motion/react';
import { useRef } from 'react';

import AircraftOverlay from '@components/AircraftOverlay/AircraftOverlay';
import { AircraftOverlayHelper } from '@components/AircraftOverlay/interactiveCard.helper';
import MotionLineGraph from '@motion/LineGraph';

import { DashboardAircraftCard } from '../../mockData/dashboard';

interface Props {
  card: DashboardAircraftCard;
  chartData: { month: string; value: number }[];
}

const DashboardContentAircraftModalCard: React.FC<Props> = ({
  card,
  chartData,
}) => {
  const CSSBlock = 'dashboard-content-aircraft-modal-card';
  const contentRef = useRef<AircraftOverlayHelper.CardContentRef>(null);

  const keyVal = (key: string, value: string | number) => {
    return (
      <div
        className={`${CSSBlock}__key-val ${
          typeof value === 'number'
            ? value > 0
              ? `${CSSBlock}__key-val--positive`
              : `${CSSBlock}__key-val--negative`
            : ''
        }`}>
        <p className={`${CSSBlock}__key`}>{key}</p>
        <p className={`${CSSBlock}__val`}>
          {typeof value === 'number'
            ? `${Number(value) > 0 ? '+' : ''}${value.toFixed(2)}%`
            : value}
        </p>
      </div>
    );
  };

  return (
    <div className={`${CSSBlock}`} onClick={() => {}}>
      <div className={`${CSSBlock}__text-contents`}>
        <p className={`${CSSBlock}__model`}>{card.model}</p>
        <p className={`${CSSBlock}__manufacturer`}>{card.make}</p>
        {card.info && card.info.map(({ key, value }) => keyVal(key, value))}
      </div>
      <div className={`${CSSBlock}__graph`}>
        <MotionLineGraph chartData={chartData} />
      </div>
      <motion.div
        initial={{ opacity: 0, scale: 0 }}
        exit={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{
          opacity: {
            delay: 0.4,
            duration: 0.4,
          },
          scale: {
            type: 'spring',
            visualDuration: 0.4,
            bounce: 0.5,
            delay: 0.4,
          },
        }}
        className={`${CSSBlock}__overlay`}>
        <AircraftOverlay ref={contentRef} scale={0.7} autoRotate={true} />
      </motion.div>
    </div>
  );
};

export default DashboardContentAircraftModalCard;
